import React from 'react'
import { M_DoubleTable } from 'src/M_Components'

export default function Entities({ roles, toastMessages, tablesOrder = [], onTablesOrderUpdate }) {

    const removeContextItems = ['Print']

    return (

        <M_DoubleTable
            parentEntity={'account'}
            childEntity={'accountOffice'}
            viewName={'accountOffice'}
            field={'AccountId'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'Entities'}
            removeContextItems={removeContextItems}
            hasConfirmation={true}
        />
    )
}